import React, { useState } from "react"
import { Link } from "react-router-dom"
import { sendPasswordResetEmail } from "firebase/auth"
import { getAuth } from "firebase/auth"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"
import { useToast } from "@/components/ui/use-toast"
import { AuthLayout } from "@/components/auth/components/AuthLayout"

const ResetPassword = () => {
  const [email, setEmail] = useState("")
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [isSuccess, setIsSuccess] = useState(false)
  const { toast } = useToast()
  const auth = getAuth()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setIsSubmitting(true)

    try {
      // Configure actionCodeSettings to use the correct URL
      const actionCodeSettings = {
        // URL you want to redirect back to. The domain (www.example.com) for this
        // URL must be in the authorized domains list in the Firebase Console.
        url: window.location.origin + "/password-reset-confirm",
        // This must be true
        handleCodeInApp: true,
      }

      await sendPasswordResetEmail(auth, email, actionCodeSettings)
      setIsSuccess(true)
      toast({
        title: "Reset email sent",
        description: "Check your email for the password reset link",
      })
    } catch (error) {
      console.error("Error sending reset email:", error)
      const errorMessage =
        error instanceof Error ? error.message : "An unknown error occurred"
      toast({
        title: "Failed to send reset email",
        description: errorMessage,
        variant: "destructive",
      })
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <AuthLayout>
      <Card className="w-full">
        <CardHeader>
          <CardTitle>Reset Password</CardTitle>
          <CardDescription>
            {isSuccess
              ? "Check your email for a link to reset your password"
              : "Enter your email address and we'll send you a link to reset your password"}
          </CardDescription>
        </CardHeader>

        <CardContent>
          {!isSuccess && (
            <form onSubmit={handleSubmit}>
              <div className="grid gap-4">
                <div className="grid gap-2">
                  <label htmlFor="email">Email</label>
                  <Input
                    id="email"
                    type="email"
                    placeholder="name@example.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                <Button type="submit" disabled={isSubmitting}>
                  {isSubmitting ? "Sending..." : "Send reset link"}
                </Button>
              </div>
            </form>
          )}

          {isSuccess && (
            <div className="text-center py-4">
              <p className="mb-4">
                If you don't receive an email within a few minutes, check your
                spam folder.
              </p>
              <Button onClick={() => setIsSuccess(false)}>
                Try another email
              </Button>
            </div>
          )}
        </CardContent>

        <CardFooter className="flex justify-center">
          <Link to="/login" className="text-sm text-blue-600 hover:underline">
            Back to login
          </Link>
        </CardFooter>
      </Card>
    </AuthLayout>
  )
}

export default ResetPassword
